"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSignatureReasonEnum = void 0;
var CustomerSignatureReasonEnum;
(function (CustomerSignatureReasonEnum) {
    CustomerSignatureReasonEnum["MISSING_CUSTOMER"] = "missing_customer";
    CustomerSignatureReasonEnum["CUSTOMER_REFUSED"] = "customer_refused";
    CustomerSignatureReasonEnum["FAULTY_HARDWARE"] = "faulty_hardware";
    CustomerSignatureReasonEnum["NO_INSTALLATION"] = "no_installation";
    CustomerSignatureReasonEnum["OTHER_REASON_CUSTOMER"] = "other_reason_customer";
    CustomerSignatureReasonEnum["OTHER_REASON_PARTNER"] = "other_reason_partner";
    CustomerSignatureReasonEnum["CANCELLATION_REASON"] = "cancellation_reason";
})(CustomerSignatureReasonEnum = exports.CustomerSignatureReasonEnum || (exports.CustomerSignatureReasonEnum = {}));
//# sourceMappingURL=customer-signature-reason-enum.js.map